<template>
  <div id="app" style="max-width: 550px; margin: 0 auto; position: relative">
    <!-- 全局授权loading -->
    <!-- <van-loading 
      v-if="authLoading" 
      type="spinner" 
      color="#8b5cf6"
      vertical
      class="global-auth-loading"
    >
      授权中...
    </van-loading> -->

    <!-- 页面内容 -->
    <div v-show="!authLoading">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
    <!-- <div class="music" @click="play">
      <div :class="['icon', 'iconfont', 'audio-icon', audioOpen ? 'audio-src' : '']">&#xe8b2;</div>
    </div> -->
    <!-- <audio :controls="true" id="audioID" ref="audio" class="aud" :src="audioUrl" @ended="audioEnded" /> -->
  </div>
</template>

<script>
import { eventBus } from "@/common";
import { isWechatAuthRequired } from "@/utils/wechatAuth";

export default {
  data() {
    return {
      audioUrl: "",
      audioOpen: false,
      audioOpenClick: false,
      loading: false,
      loadings: null,
      authLoading: false, // 授权loading状态
    };
  },
  watch: {
    $route: (to, from) => {
      document.title = to.meta.title || "";
    },
  },
  created() {
    // 监听授权loading事件
    eventBus.on(
      "auth:start",
      () => {
        this.authLoading = true;
      },
      this
    );

    eventBus.on(
      "auth:end",
      () => {
        setTimeout(() => {
          this.authLoading = false;
        }, 200);
      },
      this
    );

    // 检查是否是授权回调（URL中有code参数）
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("code") && isWechatAuthRequired()) {
      this.authLoading = true;
    }
    // 预加载无需授权的背景图，减少等待 show 授权的时间
    this.$store.dispatch("fetchGiftvoteImages");
  },
  mounted() {
    var that = this;
    // document.addEventListener('DOMContentLoaded', function () {
    //   if (that.audioOpenClick) {
    //     return
    //   }
    //   function audioAutoPlay() {
    //     var musicEle0 = document.getElementById('audioID');
    //     musicEle0.play();
    //   }
    //   console.log('DOMContentLoaded')
    //   that.audioOpen = true
    //   audioAutoPlay();
    // });
    // document.addEventListener('touchstart', function () {
    //   if (that.audioOpenClick) {
    //     return
    //   }
    //   function audioAutoPlay() {
    //     var musicEle0 = document.getElementById('audioID');
    //     musicEle0.play();
    //   }
    //   console.log('touchstart')
    //   that.audioOpen = true
    //   audioAutoPlay();
    // });
    // eventBus.on('videoPlay', () => {
    //   this.audioOpenClick = true
    //   this.pause()
    // })
  },
  beforeDestroy() {
    eventBus.off("auth:start");
    eventBus.off("auth:end");
  },
  methods: {
    autoPlay() {
      this.$wx.config({
        debug: false,
        appId: "wx8e8dc60535c9cd93",
        timestamp: 1538014977,
        nonceStr: "",
        signature: "",
        jsApiList: [],
      });
      this.$wx.ready(function () {
        document.getElementById("audioID").play();
      });
    },
    play() {
      try {
        if (this.audioOpen) {
          this.pause();
          return;
        }
        this.audioOpen = true;
        setTimeout(() => {
          this.$refs.audio.play();
        }, 500);
      } catch (error) {
        console.log(error);
      }
    },
    pause() {
      this.audioOpen = false;
      this.audioOpenClick = true;
      this.$refs.audio.pause();
    },
    audioEnded() {
      this.audioOpen = false;
      setTimeout(() => {
        this.play();
      }, 500);
    },
  },
};
</script>
<style lang="scss">
// h1,
// h2,
// h3,
// h4,
// h5,
// h6 {
//   margin-bottom: 10px;
//   width: 100%;
//   text-align: center;
//   font-size: 14px !important;
//   span {
//     font-size: 14px !important;
//   }
// }
</style>
<style lang="scss">
// p {
//   text-indent: 2em;
//   font-size: 14px;
//   width: 100%;
//   text-align: justify;
// }

@import "assets/scss/global";

#app {
  min-height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $theme-primary;
}
.main-container {
  width: 100%;
  height: 100%;
  // background-image: url("@/assets/images/bgs.jpg");
  background-size: contain;
  background-position: top;
  clear: both;
  // overflow: hidden;
  background-repeat: no-repeat;
  // position: fixed;
  // background: linear-gradient(to right, #0066ff, #00cccc);
}
.aud {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.music {
  position: absolute;
  z-index: 99999;
  top: 8px;
  right: 8px;

  .audio-icon {
    font-size: 25px;
    color: #fff;
  }

  .audio-src {
    animation: animal 4s infinite linear;
    -webkit-transform-origin: center center;
    -ms-transform-origin: center center;
    transform-origin: center center;
  }

  @keyframes animal {
    0% {
      transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
    }

    100% {
      transform: rotate(-360deg);
      -ms-transform: rotate(-360deg);
      -webkit-transform: rotate(-360deg);
    }
  }
}

.global-auth-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 9999;

  @media (min-width: 550px) {
    left: 50%;
    transform: translateX(-50%);
    max-width: 550px;
  }
}
</style>
